// ** Icons Import
import { Eye, Circle, Folder, BookOpen } from "react-feather";

export default [
	{
		header: "Эрдэм шинжилгээ",
	},
    {
        id: 'science1',
        title: 'Б цагийн тооцоо',
		icon: <Circle size={1} />,
        navLink: "/bsettings",
    },
	// {
	// 	id: "researchs",
	// 	title: "Хэвлэн нийтлэл",
	// 	icon: <Folder size={20} />,
	// 	children: [
	// 		{
	// 			id: "invention",
	// 			title: "Бүтээл",
	// 			icon: <Circle size={12} />,
	// 			navLink: "/research/invention",
	// 		},
	// 		{
	// 			id: "paper",
	// 			title: "Өгүүлэл",
	// 			icon: <Circle size={12} />,
	// 			navLink: "research/paper",
	// 		},
	// 		{
	// 			id: "note",
	// 			title: "Илтгэл",
	// 			icon: <Circle size={12} />,
	// 			navLink: "research/note",
	// 		},
	// 		{
	// 			id: "quotation",
	// 			title: "Эшлэл",
	// 			icon: <Circle size={12} />,
	// 			navLink: "research/quotation",
	// 		},
	// 		// {
	// 		// 	id: "lead-teacher",
	// 		// 	title: "Удирдсан оюутан",
	// 		// 	icon: <Circle size={12} />,
	// 		// 	navLink: "/cards/action",
	// 		// },
	// 	],
	// },
	// {
	// 	id: "projects",
	// 	title: "Төсөл, гэрээт ажил",
	// 	icon: <Folder size={20} />,
	// 	children: [
	// 		{
	// 			id: "project",
	// 			title: "Төсөл",
	// 			icon: <Circle size={12} />,
	// 			navLink: "project/project",
	// 		},
	// 		{
	// 			id: "contract-work",
	// 			title: "Гэрээт ажил",
	// 			icon: <Circle size={12} />,
	// 			navLink: "project/contract-work",
	// 		},
	// 	],
	// },
	// {
	// 	id: "intellectual-property",
	// 	title: "Оюуны өмч",
	// 	icon: <Folder size={20} />,
	// 	children: [
	// 		{
	// 			id: "new-patent",
	// 			title: "Шинэ бүтээл патент",
	// 			icon: <Circle size={12} />,
	// 			navLink: "intellectual-property/patent",
	// 		},
	// 		{
	// 			id: "model-cert",
	// 			title: "Ашигтай загвар патент",
	// 			icon: <Circle size={12} />,
	// 			navLink: "intellectual-property/model-patent",
	// 		},
	// 		{
	// 			id: "symbol-cert",
	// 			title: "Барааны тэмдгийн гэрчилгээ",
	// 			icon: <Circle size={12} />,
	// 			navLink: "intellectual-property/symbol-cert",
	// 		},
	// 		{
	// 			id: "license-cert",
	// 			title: "Лицензийн гэрээ",
	// 			icon: <Circle size={12} />,
	// 			navLink: "intellectual-property/license-cert",
	// 		},
	// 		{
	// 			id: "right-cert",
	// 			title: "Зохиогчийн эрхийн гэрчилгээ",
	// 			icon: <Circle size={12} />,
	// 			navLink: "intellectual-property/right-cert",
	// 		},
	// 	],
	// },
];
